module.exports = __webpack_public_path__ + "static/media/beebg.5d4d2abb.png";